/* eslint-disable import/prefer-default-export */
import React from 'react';
import get from 'lodash/get';
import { getRequestUrl } from 'services/api/connector';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { showContextMenu } from 'store/Contextualization/AssetDetail/actions';
import { useIntl } from 'react-intl';
import { selectSelected } from 'store/Contextualization/AssetDetail/selectors';
import { selectCurrentWorkspace } from 'store/Faraday/selectors';
import copyToClipboard from 'utils/clipboard';
import { CopyApiLinkIcon } from './styled';

export const CopyApiLink = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const workspaceSelected = useSelector(selectCurrentWorkspace);
  const vulnsSelected = useSelector((state) => selectSelected('vulns', state));
  const isBulk = vulnsSelected.length > 1;
  const vulnId = get(vulnsSelected, '[0]._id', 0);

  const onClick = () => {
    const vulnPath = `ws/${workspaceSelected}/vulns/${vulnId}`;
    const link = getRequestUrl(vulnPath);
    copyToClipboard(link);
    dispatch(showContextMenu(false));
  };

  if (isBulk) return null;
  return (
    <MenuItem
      title={ intl.formatMessage({ id: 'manage.cm.copyApiLink' }) }
      icon={ <CopyApiLinkIcon /> }
      onClick={ onClick }
    />
  );
};
